module.exports = __webpack_public_path__ + "static/img/cd400d5f87db35f11329422f7f020f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro5.png
// module id = tr7Z
// module chunks = 1